import vbAttachmentTokenService from "./vbAttachmentTokenService";
import buildAttachmentURL from "../filters/buildAttachmentURL";
import constants from "../constants";

let isSafari = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent
);

export default {

  downloadFileCommon(getTokenPromise, url) {
    let windowReference;
    if (isSafari) {
      windowReference = window.open();
    }
    return getTokenPromise.then(vbAttachmentToken => {
      // console.log(buildAttachmentURL(vbAttachmentToken.token, {downloadFileURL: url}));
      if (windowReference) {
        windowReference.location = buildAttachmentURL(vbAttachmentToken.token, {downloadFileURL: url});
      } else {
        window.open(
          buildAttachmentURL(vbAttachmentToken.token, {downloadFileURL: url}),
          "_blank"
        );
      }
    });
  },

  downloadShareLibrary(vbAttachmentId) {
    return this.downloadFileCommon(
      vbAttachmentTokenService
        .getTokenForShareLibrary(vbAttachmentId)
        .then(response => response.data),
      constants.DOWNLOAD_FILE_URL.DOWNLOAD_FILE_SHARE_LIBRARY
    );
  },

  downloadReferenceOutgoingDoc_(docId) {
    return vbAttachmentTokenService
      .getTokenForReferenceOutgoingDoc(docId)
      .then(response => response.data);
  },

  downloadReferenceOutgoingDoc(docId) {
    return this.downloadFileCommon(
      this.downloadReferenceOutgoingDoc_(docId),
      constants.DOWNLOAD_FILE_URL.REFERENCE_OUTGOING_URL
    );
  },

  downloadReferenceOutgoingDocForVT(docId) {
    return this.downloadFileCommon(
      this.downloadReferenceOutgoingDoc_(docId),
      constants.DOWNLOAD_FILE_URL.REFERENCE_OUTGOING_URL_VT
    );
  },

  getTokenForDownloadOutgoingDocWithToken(docId, objectType) {
    return vbAttachmentTokenService
      .getTokenForOutgoingDocWithToken(docId, objectType)
      .then(response => response.data);
  },

  downloadOutgoingDocWithToken(docId, objectType) {
    return this.downloadFileCommon(
      this.getTokenForDownloadOutgoingDocWithToken(docId, objectType),
      constants.DOWNLOAD_FILE_URL.OUTGOING_WITH_TOKEN_URL
    );
  },

  downloadOutgoingDocWithTokenVT(docId, objectType) {
    return this.downloadFileCommon(
      this.getTokenForDownloadOutgoingDocWithToken(docId, objectType),
      constants.DOWNLOAD_FILE_URL.OUTGOING_WITH_TOKEN_URL_VT
    );
  },

  downloadOutgoingDoc_(docId) {
    return vbAttachmentTokenService
      .getTokenForOutgoingDoc(docId)
      .then(response => response.data);
  },

  downloadOutgoingDocLanhDaoEdit_(docId) {
    return vbAttachmentTokenService
      .getTokenForOutgoingDocLanhDaoEdit(docId)
      .then(response => response.data);
  },

  downloadOutgoingDoc(docId) {
    return this.downloadFileCommon(
      this.downloadOutgoingDoc_(docId),
      constants.DOWNLOAD_FILE_URL.OUTGOING_URL
    );
  },

  downloadOutgoingDocLanhDaoEdit(docId) {
    return this.downloadFileCommon(
      this.downloadOutgoingDocLanhDaoEdit_(docId),
      constants.DOWNLOAD_FILE_URL.OUTGOING_URL
    );
  },

  downloadOutgoingDocForConfigLD(docId, objectType) {
    return this.downloadFileCommon(
      vbAttachmentTokenService.getTokenByDocIdAndObjectTypeForConfigLD(docId, objectType)
        .then(response => response.data),
      constants.DOWNLOAD_FILE_URL.OUTGOING_URL
    );
  },

  downloadOutgoingDocVT(docId) {
    return this.downloadFileCommon(
      this.downloadOutgoingDoc_(docId),
      constants.DOWNLOAD_FILE_URL.OUTGOING_URL_VT
    );
  },

  downloadOutgoingDocVTLanhDaoEdit(docId) {
    return this.downloadFileCommon(
      this.downloadOutgoingDocLanhDaoEdit_(docId),
      constants.DOWNLOAD_FILE_URL.OUTGOING_URL_VT
    );
  },

  downloadHcCaseCalendarAttachment(hcCaseCalendarId, vbAttachmentId) {
    return this.downloadFileCommon(
      vbAttachmentTokenService
        .getTokenForHcCaseCalendarAttachment(hcCaseCalendarId, vbAttachmentId)
        .then(response => response.data),
      constants.DOWNLOAD_FILE_URL.DOWNLOAD_FILE_COMMON
    );
  },

  downloadOutgoingDocVbLK_(docId) {
    return vbAttachmentTokenService
      .getTokenForOutgoingDocVbLK(docId, constants.ATTACHMENT_OBJECT_TYPE.VB_DI_REFERENCE_ATTACHMENT)
      .then(response => response.data);
  },

  downloadFileIncomingDoc(docId) {
    let windowReference;
    if (isSafari) {
      windowReference = window.open();
    }
    return vbAttachmentTokenService
      .getTokenForIncomingDoc(docId)
      .then(response => {
        let vbAttachmentToken = response.data;
        let url = buildAttachmentURL(vbAttachmentToken.token, {
          downloadFileURL:
          constants.DOWNLOAD_FILE_URL.DOWNLOAD_FILE_INCOMING_DOC
        });
        if (windowReference) {
          windowReference.location = url;
        } else {
          window.open(url, "_blank");
        }
      });
  },

  downloadDocRelateWithTask(taskId, docId) {
    let windowReference;
    if (isSafari) {
      windowReference = window.open();
    }
    return vbAttachmentTokenService
      .getTokenForDocRelateWithTask(taskId, docId)
      .then(response => {
        let vbAttachmentToken = response.data;
        let url = buildAttachmentURL(vbAttachmentToken.token, {
          downloadFileURL:
          constants.DOWNLOAD_FILE_URL.DOWNLOAD_FILE_DOC_RELATE_TASK
        });
        if (windowReference) {
          windowReference.location = url;
        } else {
          window.open(url, "_blank");
        }
      });
  },

  downloadOutgoingDocVbLKWithoutTrangKySoAndWithoutWaterMark(docId) {
    return this.downloadFileCommon(
      this.downloadOutgoingDocVbLK_(docId),
      constants.DOWNLOAD_FILE_URL
        .OUTGOING_URL_WITHOUT_TRANGKYSO_WITHOUT_WATERMARK
    );
  },

  downloadFileForHcCommandsDocRelation(
    objectId,
    objectType,
    referenceObjectType,
    referenceObjectId
  ) {
    let windowReference;
    if (isSafari) {
      windowReference = window.open();
    }
    return vbAttachmentTokenService
      .getTokenForHcCommandsDocRelation(
        objectId,
        objectType,
        referenceObjectType,
        referenceObjectId
      )
      .then(response => {
        let vbAttachmentToken = response.data;
        let url = buildAttachmentURL(vbAttachmentToken.token, {
          downloadFileURL:
          constants.DOWNLOAD_FILE_URL.DOWNLOAD_HC_COMMANDS_DOC_RELATION,
          referenceObjectType: referenceObjectType
        });
        if (windowReference) {
          windowReference.location = url;
        } else {
          window.open(url, "_blank");
        }
      });
  },

  downloadFileForHcCaseFlightFile(
    hcCaseFlightId,
    hcCaseFlightFileId,
    vbAttachmentId
  ) {
    let windowReference;
    if (isSafari) {
      windowReference = window.open();
    }
    return vbAttachmentTokenService
      .getTokenForHcCaseFlightFile(
        hcCaseFlightId,
        hcCaseFlightFileId,
        vbAttachmentId
      )
      .then(response => {
        let vbAttachmentToken = response.data;
        let url = buildAttachmentURL(vbAttachmentToken.token, {
          downloadFileURL: constants.DOWNLOAD_FILE_URL.DOWNLOAD_FILE_COMMON
        });
        if (windowReference) {
          windowReference.location = url;
        } else {
          window.open(url, "_blank");
        }
      });
  },

  downloadFileForTaskAttachment(tkTaskId, attachmentId) {
    let windowReference;
    if (isSafari) {
      windowReference = window.open();
    }
    return vbAttachmentTokenService
      .getTokenForTaskAttachment(tkTaskId, attachmentId)
      .then(response => {
        let vbAttachmentToken = response.data;
        let url = buildAttachmentURL(vbAttachmentToken.token, {
          type: constants.DOWNLOAD_FILE_URL.DOWNLOAD_FILE_COMMON
        });
        if (windowReference) {
          windowReference.location = url;
        } else {
          window.open(url, "_blank");
        }
      });
  },

  downloadFileForAttachmentComment(attachmentId) {
    let windowReference;
    if (isSafari) {
      windowReference = window.open();
    }
    return vbAttachmentTokenService
      .getTokenAttachmentComment(attachmentId)
      .then(response => {
        let vbAttachmentToken = response.data;
        let url = buildAttachmentURL(vbAttachmentToken.token, {
          downloadFileURL: constants.DOWNLOAD_FILE_URL.DOWNLOAD_FILE_COMMON
        });
        if (windowReference) {
          windowReference.location = url;
        } else {
          window.open(url, "_blank");
        }
      });
  },

  downloadReferenceOutgoingDocForBlockedRole(docId, blockedUserId) {
    return this.downloadFileCommon(
      vbAttachmentTokenService.getTokenForReferenceOutgoingDocForBlockedRole(docId, blockedUserId)
        .then(response => response.data),
      constants.DOWNLOAD_FILE_URL.REFERENCE_OUTGOING_URL
    );
  },

  downloadReferenceOutgoingDocForVTForBlockedRole(docId, blockedUserId) {
    return this.downloadFileCommon(
      vbAttachmentTokenService.getTokenForReferenceOutgoingDocForBlockedRole(docId, blockedUserId)
        .then(response => response.data),
      constants.DOWNLOAD_FILE_URL.REFERENCE_OUTGOING_URL_VT
    );
  },

  downloadOutgoingDocForBlockedRole(docId, blockedUserId) {
    return this.downloadFileCommon(
      vbAttachmentTokenService.getTokenForOutgoingDocForBlockedRole(docId, blockedUserId)
        .then(response => response.data),
      constants.DOWNLOAD_FILE_URL.OUTGOING_URL
    );
  },

  downloadOutgoingDocWithoutTrangKySoAndWithoutWaterMarkForBlockedRole(docId, blockedUserId) {
    return this.downloadFileCommon(
      vbAttachmentTokenService.getTokenForOutgoingDocForBlockedRole(docId, blockedUserId)
        .then(response => response.data),
      constants.DOWNLOAD_FILE_URL.OUTGOING_URL_WITHOUT_TRANGKYSO_WITHOUT_WATERMARK
    );
  },

  downloadOutgoingDocForVTBlockedRole(docId, blockedUserId) {
    return this.downloadFileCommon(
      vbAttachmentTokenService.getTokenForOutgoingDocForBlockedRole(docId, blockedUserId)
        .then(response => response.data),
      constants.DOWNLOAD_FILE_URL.OUTGOING_URL_VT
    );
  },

  downloadOutgoingDocWithTokenForBlockedRole(docId, objectType, blockedUserId) {
    return this.downloadFileCommon(
      vbAttachmentTokenService.getTokenForOutgoingDocWithTokenForBlockedRole(docId, objectType, blockedUserId)
        .then(response => response.data),
      constants.DOWNLOAD_FILE_URL.OUTGOING_WITH_TOKEN_URL
    );
  },

  downloadOutgoingDocWithTokenForVTBlockedRole(docId, objectType, blockedUserId) {
    return this.downloadFileCommon(
      vbAttachmentTokenService.getTokenForOutgoingDocWithTokenForBlockedRole(docId, objectType, blockedUserId)
        .then(response => response.data),
      constants.DOWNLOAD_FILE_URL.OUTGOING_WITH_TOKEN_URL_VT
    );
  },

  downloadRelationDoc(idDocRelation) {
    let windowReference;
    if (isSafari) {
      windowReference = window.open();
    }
    return vbAttachmentTokenService
      .getTokenDocRelation(idDocRelation)
      .then(response => {
        let vbAttachmentToken = response.data;
        let url = buildAttachmentURL(vbAttachmentToken.token, {
          type: constants.DOWNLOAD_OPTION.TYPE.ORIGINAL
        });
        if (windowReference) {
          windowReference.location = url;
        } else {
          window.open(url, "_blank");
        }
      });
  },
};



// WEBPACK FOOTER //
// ./src/services/downloadService.js